import React, { useState, useEffect, useCallback } from 'react'; 
import { auth, db } from '../../Components/LoginComp/firebase';
import { collection, getDocs, deleteDoc, doc,  query, orderBy, getFirestore, where, updateDoc  } from 'firebase/firestore';
import moment from 'moment'; 
import { writeFile, utils } from 'xlsx';

import * as XLSX from "xlsx";


import { getAuth } from 'firebase/auth';

import {
  MdAccessTime, MdLocationOn, MdPeople, MdEmail,
  MdPhone, MdPerson, MdNotes, MdVolumeUp, MdEvent, MdAttachMoney
} from "react-icons/md";


import './adminpanel.css';

function AdminPanel() {

  const [activeTab, setActiveTab] = useState('viewAlmsgiving');
  const [users, setUsers] = useState([]);

  //fetch all abstracts  
  const [abstracts, setAbstracts] = useState([]); // State to store abstracts

  

  const [bookings, setBookings] = useState([]);
  const db = getFirestore();
  
  useEffect(() => {
    const fetchAllDhammaEvents = async () => {
      try {
        const eventsRef = collection(db, "dhammaEvents");
        const eventsSnapshot = await getDocs(eventsRef);
  
        const eventBookings = eventsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          date: doc.data().date?.toDate(),
          createdAt: doc.data().createdAt?.toDate()
        }));
  
        const sortedEvents = eventBookings.sort((a, b) => b.date - a.date);
        setBookings(sortedEvents);
      } catch (error) {
        console.error("Error fetching dhamma events:", error);
      }
      setLoading(false);
    };
  
    fetchAllDhammaEvents();
  }, [db]);
  
  const formatDate = (date) => {
    if (!date) return "Date not specified";
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  




///////////////////////////////////////     arama poojava    ///////////////////////////////////////////////////

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  const [editData, setEditData] = useState(null);

 
 const fetchData = async () => {
    const snap = await getDocs(collection(db, "aramapoojava"));
    const list = snap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setData(list);
  };

   useEffect(() => {
    fetchData();
  }, []);

  
  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this booking?")) return;

    await deleteDoc(doc(db, "aramapoojava", id));
    fetchData();
  };

  // EDIT SAVE
  const handleUpdate = async () => {
    await updateDoc(doc(db, "aramapoojava", editData.id), {
      name: editData.name,
      phone: editData.phone,
      email: editData.email,
      address: editData.address
    });

    alert("Updated Successfully");
    setEditData(null);
    fetchData();
  };

  // FILTER
  const filteredData = data.filter(item => {

    const matchName = item.name
      .toLowerCase()
      .includes(search.toLowerCase());

    const itemDate = moment(item.date);

    const matchYear = year
      ? itemDate.format("YYYY") === year
      : true;

    const matchMonth = month
      ? itemDate.format("MM") === month
      : true;

    return matchName && matchYear && matchMonth;
  });

  

















  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();
    }
  }, [activeTab, fetchUsers]);




  // Remove user with confirmation
  const handleRemoveUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (!confirmDelete) return; 

    try {
      await deleteDoc(doc(db, 'users', userId));  
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); 
    } catch (error) {
      console.error("Error removing user:", error.message);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };



  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);












  useEffect(() => {
    const fetchAbstracts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "abstracts"));
        const fetchedAbstracts = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setAbstracts(fetchedAbstracts);
      } catch (error) {
        console.error("Error fetching abstracts: ", error);
      }
    };
  
    fetchAbstracts();
  }, []);
  
  // // Function to download an abstract as a .txt file
  // const handleDownload = (abstract) => {
  //   const text = `Title: ${abstract.title}\n\nAuthor: ${abstract.name}\nEmail: ${abstract.email}\n\nAbstract:\n${abstract.abstract}`;
  //   const blob = new Blob([text], { type: "text/plain" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = `${abstract.title.replace(/\s+/g, "_")}.txt`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };



  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (activeTab === "viewMessage") {
      const fetchMessages = async () => {
        try {
          const querySnapshot = await getDocs(collection(db, "contacts"));
          const fetchedMessages = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setMessages(fetchedMessages);
        } catch (error) {
          console.error("Error fetching messages:", error);
        }
      };

      fetchMessages();
    }
  }, [activeTab]);




  //view all alms giving
  // const [appointments, setAppointments] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchAppointments = async () => {
  //     try {
  //       const q = query(
  //         collection(db, 'appointments'),
  //         orderBy('createdAt', 'desc') // Sort by creation date (newest first)
  //       );
        
  //       const querySnapshot = await getDocs(q);
  //       const appointmentsData = [];
        
  //       querySnapshot.forEach((doc) => {
  //         appointmentsData.push({
  //           id: doc.id,
  //           ...doc.data(),
  //           // Convert Firestore timestamp to readable date
  //           date: doc.data().date.toDate().toLocaleDateString(),
  //           createdAt: doc.data().createdAt.toDate().toLocaleString()
  //         });
  //       });

  //       setAppointments(appointmentsData);
  //       setLoading(false);
  //     } catch (err) {
  //       console.error('Error fetching appointments:', err);
  //       setError('Failed to load appointments');
  //       setLoading(false);
  //     }
  //   };

  //   fetchAppointments();
  // }, []);

  // if (loading) {
  //   return <div className="loading-spinner">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="error-message">{error}</div>;
  // }
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔹 Filters
  const [selectedYear, setSelectedYear] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [selectedMealType, setSelectedMealType] = useState("all");

  // 🔹 Fetch appointments
  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const q = query(
          collection(db, "appointments"),
          orderBy("createdAt", "desc")
        );

        const querySnapshot = await getDocs(q);
        const data = [];

        querySnapshot.forEach((docSnap) => {
          const docData = docSnap.data();
          const dateObj = docData.date.toDate();
          const createdAtObj = docData.createdAt.toDate();

          data.push({
            id: docSnap.id,
            ...docData,
            dateObj,
            date: dateObj.toLocaleDateString(),
            createdAt: createdAtObj.toLocaleString()
          });
        });

        setAppointments(data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Failed to load appointments");
        setLoading(false);
      }
    };

    fetchAppointments();
  }, []);

 

  // 🔹 Apply filters
  const filteredAppointments = appointments.filter((appointment) => {
    const yearMatch =
      selectedYear === "all" ||
      appointment.dateObj.getFullYear().toString() === selectedYear;

    const monthMatch =
      selectedMonth === "all" ||
      appointment.dateObj.getMonth().toString() === selectedMonth;

    const mealMatch =
      selectedMealType === "all" ||
      appointment.mealType === selectedMealType;

    return yearMatch && monthMatch && mealMatch;
  });

  if (loading) return <div className="loading-spinner">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;








// Add this function to your component
const handleDeleteAppointment = async (appointmentId) => {
  if (window.confirm('Are you sure you want to delete this appointment?')) {
    try {
      await deleteDoc(doc(db, 'appointments', appointmentId));
      setAppointments(appointments.filter(app => app.id !== appointmentId));
      alert('Appointment deleted successfully');
    } catch (err) {
      console.error('Error deleting appointment:', err);
      alert('Failed to delete appointment');
    }
  }
};














//fetch all the Monastery offering
function MonasteryOfferings() {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllDonations = async () => {
      try {
        const db = getFirestore();
        const donationsRef = collection(db, "monasteryDonations");
        const q = query(donationsRef, orderBy("createdAt", "desc"));
        
        const querySnapshot = await getDocs(q);
        const donationsData = [];
        
        querySnapshot.forEach((doc) => {
          donationsData.push({
            id: doc.id,
            ...doc.data(),
            createdAt: doc.data().createdAt?.toDate().toLocaleString() || "Unknown date"
          });
        });

        setDonations(donationsData);
      } catch (err) {
        console.error("Error fetching donations:", err);
        setError("Failed to load donations. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchAllDonations();
  }, []);

  if (loading) {
    return <div className="loading-spinner">Loading offerings...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="all-donations-container">
      {donations.length > 0 ? (
        <>
          <div className="donations-summary">
            <p>Total Offerings: {donations.length}</p>
            <p>Total Amount: AUD {donations.reduce((sum, d) => sum + (+d.amount || 0), 0)}</p>

          </div>
          
          <div className="donations-list">
            {donations.map((donation) => (
              <div key={donation.id} className="donation-card">
                <div className="donation-header">
                  <h4>Donation</h4>
                  <span className="donation-amount">
                    AUD {donation.amount}
                  </span>
                </div>
                <div className="donation-details">
                  <p><MdPerson /> {donation.firstName} {donation.lastName}</p>
                  <p><MdEmail /> {donation.email}</p>
                  <p><MdPhone /> {donation.phone}</p>
                  {donation.address && <p><MdLocationOn /> {donation.address}</p>}
                  {donation.reason && <p><MdNotes /> Reason: {donation.reason}</p>}
                  <p><MdEvent /> {donation.donationDate}</p>
                                      <p><MdAttachMoney /> {donation.amount}</p>
                  <p><MdEvent /> Created On: {donation.createdAt}</p>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className="no-donations">No monastery offerings found.</p>
      )}
    </div>
  );
}


  

  
  
const exportToExcel = () => {
  if (appointments.length === 0) return;

  const worksheetData = appointments.map((a) => ({
    Date: a.date,
    "Meal Type": a.mealType === "breakfast" ? "Breakfast" : "Lunch",
    Name: a.name,
    Phone: a.phone,
    Email: a.email,
    Address: a.address,
    "Alms Offer Location": a.location,
    "No of Monks": a.numberOfPeople,
    "Booked On": a.createdAt,
  }));

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Alms Offering");

  XLSX.writeFile(workbook, "alms_offering_data.xlsx");
};

 


///////////////////////////////////////     arama poojava    ///////////////////////////////////////////////////


 




  return (
    <div className="admin-panel">
      <div className="top-bar">
        <ul className="tabs">
          <li className={`tab ${activeTab === 'viewAlmsgiving' ? 'active' : ''}`} onClick={() => handleTabClick('viewAlmsgiving')}>
            View All Alms Offering
          </li>
          <li className={`tab ${activeTab === 'viewEvents' ? 'active' : ''}`} onClick={() => handleTabClick('viewEvents')}>
            View All Pirith Chanting/Dhamma Speech
          </li>
          <li className={`tab ${activeTab === 'viewMonastery' ? 'active' : ''}`} onClick={() => handleTabClick('viewMonastery')}>
            View All monastery Offerings
          </li>

          <li className={`tab ${activeTab === 'aramaPooja' ? 'active' : ''}`} onClick={() => handleTabClick('aramaPooja')}>
            View All Arama Pooja
          </li>

          <li className={`tab ${activeTab === 'viewUsers' ? 'active' : ''}`} onClick={() => handleTabClick('viewUsers')}>
            View All Members
          </li>
          <li className={`tab ${activeTab === 'viewMessage' ? 'active' : ''}`} onClick={() => handleTabClick('viewMessage')}>
            View All Messages
          </li>

          <li className={`tab ${activeTab === 'manageUsers' ? 'active' : ''}`} onClick={() => handleTabClick('manageUsers')}>
            Manage Members
          </li>
        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">



{activeTab === 'viewMonastery' && (
  <div className="tab-content active">
    <h3>View All Monastery Offerings</h3>
    <MonasteryOfferings />
  </div>
)}


{/***************************************************   Arama Poojava ****************************************************************/}


{activeTab === "aramaPooja" && (
    <div className="admin-container">

      <h3>Arama Pooja Bookings</h3>

      {/* FILTERS */}
      <div className="filters">

        <input
          placeholder="Search by name"
          value={search}
          onChange={e=>setSearch(e.target.value)}
        />

        <select onChange={e=>setYear(e.target.value)}>
          <option value="">All Years</option>
          {[2025,2026,2027].map(y=>(
            <option key={y}>{y}</option>
          ))}
        </select>

        <select onChange={e=>setMonth(e.target.value)}>
          <option value="">All Months</option>
          {moment.months().map((m,i)=>(
            <option key={i} value={String(i+1).padStart(2,"0")}>
              {m}
            </option>
          ))}
        </select>

      </div>

      {/* TABLE */}
      <table className="admin-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Address</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {filteredData.map(item=>(
            <tr key={item.id}>
              <td>{item.date}</td>
              <td>{item.name}</td>
              <td>{item.phone}</td>
              <td>{item.email}</td>
              <td>{item.address}</td>

              <td>
                <button
                  onClick={()=>setEditData(item)}
                >
                  Edit
                </button>

                <button
                  onClick={()=>handleDelete(item.id)}
                  className="danger"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* EDIT MODAL */}
      {editData && (
        <div className="modal">
          <div className="modal-box">

            <h4>Edit Booking</h4>

            <input
              value={editData.name}
              onChange={e=>setEditData({
                ...editData,
                name:e.target.value
              })}
            />

            <input
              value={editData.phone}
              onChange={e=>setEditData({
                ...editData,
                phone:e.target.value
              })}
            />

            <input
              value={editData.email}
              onChange={e=>setEditData({
                ...editData,
                email:e.target.value
              })}
            />

            <input
              value={editData.address}
              onChange={e=>setEditData({
                ...editData,
                address:e.target.value
              })}
            />

            <button onClick={handleUpdate}>
              Save Changes
            </button>

            <button
              onClick={()=>setEditData(null)}
            >
              Cancel
            </button>

          </div>
        </div>
      )}

    </div>
)}













{/* {activeTab === "viewAlmsgiving" && (
 <div className="tab-content active">
 <h3>View Alms Offering</h3>
 
 {appointments.length === 0 ? (
   <p className="no-appointments">No alms giving appointments found.</p>
 ) : (
   <div className="appointments-table-container">
     <table className="appointments-table">
       <thead>
         <tr>
           <th>Date</th>
           <th>Meal Type</th>
           <th>Name</th>
           <th>Phone</th>
           <th>Email</th>
           <th>address</th>
           <th>Alms Offer Location</th>
           <th>No of Monks</th>
           <th>Booked On</th>
           <th>Action</th>
         </tr>
       </thead>
       <tbody>
         {appointments.map((appointment) => (
           <tr key={appointment.id}>
             <td>{appointment.date}</td>
             <td className={`meal-type ${appointment.mealType}`}>
               {appointment.mealType === 'breakfast' ? 'Breakfast' : 'Lunch'}
             </td>
             <td>{appointment.name}</td>
             <td>{appointment.phone}</td>
             <th>{appointment.email}</th>
             <td>{appointment.address}</td>
             <td>{appointment.location}</td>
             <td>{appointment.numberOfPeople}</td>
             <td>{appointment.createdAt}</td>
           </tr>
         ))}
       </tbody>
     </table>
   </div>
 )}
</div>
        )} */}

{/* {activeTab === "viewAlmsgiving" && (
  <div className="tab-content active">
    <h3>View Alms Offering</h3>

    <button className="export-btn" onClick={exportToExcel}>
      Export to Excel
    </button>
    
    {appointments.length === 0 ? (
      <p className="no-appointments">No alms giving appointments found.</p>
    ) : (
      <div className="appointments-table-container">
        <table className="appointments-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Meal Type</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>address</th>
              <th>Alms Offer Location</th>
              <th>No of Monks</th>
              <th>Booked On</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {appointments.map((appointment) => (
              <tr key={appointment.id}>
                <td>{appointment.date}</td>
                <td className={`meal-type ${appointment.mealType}`}>
                  {appointment.mealType === 'breakfast' ? 'Breakfast' : 'Lunch'}
                </td>
                <td>{appointment.name}</td>
                <td>{appointment.phone}</td>
                <th>{appointment.email}</th>
                <td>{appointment.address}</td>
                <td>{appointment.location}</td>
                <td>{appointment.numberOfPeople}</td>
                <td>{appointment.createdAt}</td>
                <td>
                  <button 
                    className="delete-button"
                    onClick={() => handleDeleteAppointment(appointment.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
)} */}
 {activeTab === "viewAlmsgiving" && (

        <div className="tab-content active">
          <h3>View Alms Offering</h3>

          {/* 🔹 Filters */}
          <div className="filters-container">
            <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
              <option value="all">All Years</option>
              {[2024, 2025, 2026, 2027].map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>

            <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
              <option value="all">All Months</option>
              {[
                "January","February","March","April","May","June",
                "July","August","September","October","November","December"
              ].map((month, index) => (
                <option key={index} value={index}>{month}</option>
              ))}
            </select>

            <select
              value={selectedMealType}
              onChange={(e) => setSelectedMealType(e.target.value)}
            >
              <option value="all">All Meals</option>
              <option value="breakfast">Breakfast</option>
              <option value="lunch">Lunch</option>
            </select>

            <button className="export-btn" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>

          {/* 🔹 Table */}
          {filteredAppointments.length === 0 ? (
            <p className="no-appointments">No alms giving appointments found.</p>
          ) : (
            <div className="appointments-table-container">
              <table className="appointments-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Meal Type</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Address</th>
                    <th>Alms Offer Location</th>
                    <th>No of Monks</th>
                    <th>Booked On</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAppointments.map((appointment) => (
                    <tr key={appointment.id}>
                      <td>{appointment.date}</td>
                      <td className={`meal-type ${appointment.mealType}`}>
                        {appointment.mealType === "breakfast" ? "Breakfast" : "Lunch"}
                      </td>
                      <td>{appointment.name}</td>
                      <td>{appointment.phone}</td>
                      <td>{appointment.email}</td>
                      <td>{appointment.address}</td>
                      <td>{appointment.location}</td>
                      <td>{appointment.numberOfPeople}</td>
                      <td>{appointment.createdAt}</td>
                      <td>
                        <button
                          className="delete-button"
                          onClick={() => handleDeleteAppointment(appointment.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      
      )}


















{activeTab === 'viewMessage' && (
  <div className="abstract-download-section">
        <h3 className="download-heading">View All Messages</h3>
        <div className="messages-list">
          {messages.length > 0 ? (
            messages.map((message) => (
              <div key={message.id} className="message-item">
                <p><strong>Name:</strong> {message.name}</p>
                <p><strong>Email:</strong> {message.email}</p>
                <p><strong>Subject:</strong> {message.subject}</p>
                <p><strong>Message:</strong> {message.message}</p>
                <p><strong>Received On:</strong> {message.timestamp?.toDate().toLocaleString()}</p>
                <hr />
              </div>
            ))
          ) : (
            <p>No messages found.</p>
          )}
        </div>
      </div>
)}











{activeTab === 'viewEvents' && (
  <div className="events-view-section">
    <h3 className="view-heading">Scheduled Pirith Chanting/Dhamma Speech Appointments</h3>
    <>
    
    
        {loading ? (
          <p>Loading...</p>
        ) : bookings.length > 0 ? (
          <div className="bookings-list">
            {bookings.map((booking, index) => (
              <div key={booking.id || index} className="booking-card">
                <div className="booking-header">
                  <h3><MdVolumeUp /> {booking.eventType}</h3>
                  <span className="booking-date">{formatDate(booking.date)}</span>
                </div>

                <div className="booking-details">
                  <div className="detail-row"><MdPerson className="detail-icon" /><span>{booking.name}</span></div>
                  <div className="detail-row"><MdEmail className="detail-icon" /><span>{booking.email}</span></div>
                  <div className="detail-row"><MdPhone className="detail-icon" /><span>{booking.phone}</span></div>
                  <div className="detail-row"><MdPeople className="detail-icon" /><span>Expected Attendees: {booking.numberOfPeople}</span></div>
                  <div className="detail-row"><MdAccessTime className="detail-icon" /><span>Time: {booking.timeSlotDisplay}</span></div>

                  {booking.specialRequests && (
                    <div className="detail-row"><MdNotes className="detail-icon" /><span>Special Requests: {booking.specialRequests}</span></div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-abstraction">
            You haven't made any Dhamma event bookings yet. <br /><br />
            With hearts full of reverence, we warmly invite you to be part
            of our spiritual activities at the Ehipassiko Buddhist Center.
          </p>
        )}
  
    </>
    
</div>

)}
















        {/* {activeTab === 'viewUsers' && (
          <div className="tab-content active">
            <h3>View All Members</h3>
            <table className="users-table">
              <thead>
                <tr>
                  <th>Membership No</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.membershipNumber}</td>
                    <td>{user.name}</td>
                    <td>{user.country}</td>
                    <td>{user.email}</td>
                    <td>{user.contactNo}</td>
                    <td>{user.role}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
 */}


{activeTab === 'viewUsers' && (
  <div className="tab-content active">
    <div className="table-header">
      <h3>View All Members</h3>
      <button 
        onClick={() => {
          const ws = utils.json_to_sheet(users.map(user => ({
            'Membership No': user.membershipNumber,
            'Name': user.name,
            'Address': user.country,
            'Email': user.email,
            'Contact No': user.contactNo,
            'Role': user.role
          })));
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, "Members");
          writeFile(wb, "members_list.xlsx");
        }}
        className="view-all-user-btn"
      >
        Download Excel
      </button>
    </div>
    <table className="users-table">
      <thead>
        <tr>
          <th>Membership No</th>
          <th>Name</th>
          <th>Address</th>
          <th>Email</th>
          <th>Contact No</th>
          <th>Role</th>
        </tr>
      </thead>
      <tbody>
        {users.map(user => (
          <tr key={user.id}>
            <td>{user.membershipNumber}</td>
            <td>{user.name}</td>
            <td>{user.country}</td>
            <td>{user.email}</td>
            <td>{user.contactNo}</td>
            <td>{user.role}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}



















        {activeTab === 'manageUsers' && (
          <div className="tab-content active">
            <h3>Manage Members</h3>
            <table className="users-table">
              <thead>
                <tr>
                  <th>Membership No</th>
                <th>Name</th>
                  <th>Address</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.membershipNumber}</td>
                    <td>{user.name}</td>
                    <td>{user.country}</td>
                    <td>{user.email}</td>
                    <td>{user.contactNo}</td>
                    <td>{user.role}</td>
                    <td>
                      <button className="remove-btn" onClick={() => handleRemoveUser(user.id)}>
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPanel;
